type Trait = {
	name: string;
	value: string | boolean | number;
};

type PersonalizationResponse = {
	attributes: Trait[];
};

type UserActivationDateTrait = 'jira-software_first_active' | 'confluence_first_active';

export const isUserTooNew = async (
	cloudId: string,
	userId: string,
	trait: UserActivationDateTrait,
): Promise<boolean> => {
	const requiredDaysActive = 14;
	const userTraits = await fetchUserPersonalization(cloudId, userId);
	const activationDateTrait = userTraits.find((t) => t.name === trait);
	if (!activationDateTrait || typeof activationDateTrait.value !== 'string') {
		return true;
	}
	const activationDate = new Date(activationDateTrait.value);
	return isTodayBeforeThreshold(activationDate, requiredDaysActive);
};

export const isTodayBeforeThreshold = (startDate: Date, thresholdDays: number): boolean => {
	const today = new Date();
	const dateAfterThreshold = new Date(startDate);
	dateAfterThreshold.setDate(startDate.getDate() + thresholdDays);
	return today <= dateAfterThreshold;
};

const getPersonalizationSiteUserTraitsUrl = (cloudId: string, userId: string) =>
	`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;

const fetchUserPersonalization = async (
	cloudId: string,
	userId: string,
): Promise<PersonalizationResponse['attributes']> => {
	const response = await fetch(getPersonalizationSiteUserTraitsUrl(cloudId, userId), {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
			'x-atlassian-mau-ignore': 'true',
		},
	});

	const { attributes } = await response.json();
	return attributes;
};
